import { render, staticRenderFns } from "./FormattedText.vue?vue&type=template&id=2ddc8646&scoped=true"
import script from "./FormattedText.vue?vue&type=script&lang=ts"
export * from "./FormattedText.vue?vue&type=script&lang=ts"
import style0 from "./FormattedText.vue?vue&type=style&index=0&id=2ddc8646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc8646",
  null
  
)

export default component.exports